// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"article-card_wrapper__6YYxc","name":"article-card_name__jYih1","excerpt":"article-card_excerpt__pYxrl","title":"article-card_title__g4lSL"};